import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-trigger"
export default class extends Controller {
  openModal(event) {
    event.preventDefault()

    // Remove existing modal if it exists
    const existingModal = document.querySelector('[data-controller="profile-modal"]')
    if (existingModal) {
      existingModal.remove()
    }

    // Fetch the modal HTML and insert it
    fetch('/user_profile/modal', {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.text()
    })
    .then(html => {
      // Insert HTML directly at end of body
      // This allows Stimulus to properly initialize controllers
      document.body.insertAdjacentHTML('beforeend', html)

      // Wait for Stimulus to connect, then open the modal
      requestAnimationFrame(() => {
        const modal = document.querySelector('[data-controller="profile-modal"]')
        if (modal) {
          const controller = this.application.getControllerForElementAndIdentifier(modal, 'profile-modal')
          if (controller) {
            controller.open()
          }
        }
      })
    })
    .catch(error => {
      console.error('Error loading profile modal:', error)
      alert('Failed to load profile form. Please try again.')
    })
  }
}
